/* [BD Feat] Featured collections section JS for slider, products fade in/fade out START*/

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.collection-slider-products[data-section-id]').forEach(function (sectionWrapper) {
      var sectionId = sectionWrapper.getAttribute('data-section-id');
      if (!sectionId) return;
  
      var collectionNamesList = document.querySelector(`#collections-names-${sectionId}`);
      var collectionNameItems = collectionNamesList?.querySelectorAll('.collection-name') || [];
  
      const tabsLoop = checkChildWidth(collectionNamesList, collectionNameItems);
  
      var collectionsSlider = new Flickity(`#collections-slider-${sectionId}`, {
        cellAlign: 'center',
        contain: true,
        pageDots: true,
        prevNextButtons: false,
        adaptiveHeight: true,
        groupCells: 1,
        wrapAround: true
      });
  
      var flktyCollectionsNames = new Flickity(`#collections-names-${sectionId}`, {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        wrapAround: tabsLoop,
        selectedIndex: 0
      });
  
      var syncing = false;
      var lastSelectedCollection = null;
  
      flktyCollectionsNames.on('staticClick', function (event, pointer, cellElement, cellIndex) {
        if (typeof cellIndex !== 'undefined') {
          flktyCollectionsNames.select(cellIndex, true, false);
        }
      });
  
      collectionsSlider.on('select', function () {
        if (!syncing) {
          syncing = true;
          flktyCollectionsNames.select(collectionsSlider.selectedIndex);
  
          var selectedElement = collectionsSlider.selectedElement;
          var handle = selectedElement?.getAttribute('data-collection-handle');
  
          if (lastSelectedCollection !== handle) {
            showProducts(handle, true);
            lastSelectedCollection = handle;
          }
  
          syncing = false;
        }
      });
  
      flktyCollectionsNames.on('select', function () {
        if (!syncing) {
          syncing = true;
          collectionsSlider.select(flktyCollectionsNames.selectedIndex);
  
          var selectedElement = flktyCollectionsNames.selectedElement;
          var handle = selectedElement?.getAttribute('data-collection-handle');
  
          if (lastSelectedCollection !== handle) {
            showProducts(handle, true);
            lastSelectedCollection = handle;
          }
  
          syncing = false;
        }
      });
  
      var productsContainer = document.getElementById(`products-display-${sectionId}`);
      var allProductsGroups = productsContainer?.querySelectorAll('.products-for-collection') || [];
  
      function showProducts(handle, isFadeEffect) {
        if (!handle || !productsContainer) return;
  
        if (isFadeEffect) {
          productsContainer.style.opacity = 0;
        }
  
        setTimeout(function () {
          allProductsGroups.forEach(function (group) {
            group.style.display = 'none';
          });
  
          var selectedGroup = document.getElementById(`products-${handle}-${sectionId}`);
          if (selectedGroup) {
            selectedGroup.style.display = 'flex';
            
            selectedGroup.style.gap = '1.5rem';
          }
  
          if (isFadeEffect) {
            productsContainer.style.opacity = 1;
          }
        }, 300);
      }
  
      collectionNameItems.forEach(function (nameEl, index) {
        nameEl.addEventListener('click', function () {
          if (!nameEl.classList.contains('active')) {
            collectionsSlider.select(index);
            var handle = nameEl.getAttribute('data-collection-handle');
            showProducts(handle, true);
          }
        });
      });
  
      // Initial Load
      var firstSlide = document.querySelector(`#collections-slider-${sectionId} .collection-slide`);
      if (firstSlide) {
        var firstHandle = firstSlide.getAttribute('data-collection-handle');
        showProducts(firstHandle, false);
        if (collectionNameItems.length > 0) {
          collectionNameItems[0].classList.add('active');
        }
        lastSelectedCollection = firstHandle;
      }
  
      document.addEventListener('shopify:section:load', function (event) {
        collectionsSlider.reloadCells();
        flktyCollectionsNames.reloadCells();
  
        var refreshedFirstSlide = document.querySelector(`#collections-slider-${sectionId} .collection-slide`);
        var refreshedHandle = refreshedFirstSlide?.getAttribute('data-collection-handle');
        if (refreshedHandle) {
          showProducts(refreshedHandle, false);
        }
      });
  
      // Check child width function (same for all)
      function checkChildWidth(parentElement, childElements) {
        try {
          const parentWidth = parentElement.offsetWidth;
          let totalChildWidth = 0;
  
          childElements.forEach((child, index) => {
            const childWidth = child.offsetWidth;
            const style = window.getComputedStyle(child);
            const marginRight = parseInt(style.marginRight, 10) || 0;
  
            if (index < childElements.length - 1) {
              totalChildWidth += childWidth + marginRight;
            } else {
              totalChildWidth += childWidth;
            }
          });
  
          return totalChildWidth > parentWidth;
        } catch (error) {
          console.error("Error in checkChildWidth:", error);
          return false;
        }
      }
    });
  });
  
/* [BD Feat] Featured collections section JS for slider, products fade in/fade out START*/